import { useState } from 'react';
import { LayoutModule } from '../../../../layout/modules';
import { Box } from '@mui/material';
import AssignmentIcon from '@mui/icons-material/Assignment';
import QuizIcon from '@mui/icons-material/Quiz';
import ActionButtonGroup from '../../../../components/general/buttons/actionButtonGroup';
import { SURVEYS, SURVEYS_EDIT } from '../../../../../routes/paths';
import { useSurveyDetail } from './hook';
import { SurveyData } from './data';
import { SurveyQuestions } from './questions';
import { SurveyRegisterHistory } from './registerHistory';
import { SurveyLogs } from '../logs';
import { asyncGetSurveyLogs } from '../../../../../services/survey.service';
import { useSelector } from 'react-redux';
import { RootState } from '../../../../../redux/store';
import { isOnlyViewProfile } from '../../../../../shared/types/profiles';

export const SurveyDetail = () => {
    const { logUser } = useSelector((state: RootState) => state.general);
    const { type } = logUser || {};
    const { survey, loading } = useSurveyDetail();
    const [showHistorical, setShowHistorical] = useState(false);
    const [historical, setHistorical] = useState<any[]>([]);

    const toggleHistorical = async () => {
        if (!showHistorical && survey?.id && historical.length === 0) {
            // Cargar logs solo la primera vez
            const data = await asyncGetSurveyLogs(survey.id);
            setHistorical(data);
        }
        setShowHistorical(!showHistorical);
    };

    // Si está mostrando logs, solo mostrar los logs
    if (showHistorical && survey?.id) {
        return (
            <LayoutModule
                title="Historial de Cambios"
                withAccordion={false}
                additionalButtons={
                    <ActionButtonGroup
                        id={survey?.id || ''}
                        buttonSearch={{
                            show: true,
                            route: SURVEYS,
                        }}
                        buttonUpdate={{
                            show: !isOnlyViewProfile(type),
                            route: SURVEYS_EDIT,
                        }}
                        buttonLog={{
                            show: Boolean(survey?.id),
                        }}
                        onHistoricalShow={toggleHistorical}
                    />
                }
            >
                <Box sx={{ marginTop: 2 }}>
                    <SurveyLogs historical={historical} showHistorical={true} />
                </Box>
            </LayoutModule>
        );
    }

    return (
        <>
            <LayoutModule
                title="Detalle encuesta"
                withAccordion={false}
                additionalButtons={
                    <ActionButtonGroup
                        id={survey?.id || ''}
                        buttonSearch={{
                            show: true,
                            route: SURVEYS,
                        }}
                        buttonUpdate={{
                            show: !isOnlyViewProfile(type),
                            route: SURVEYS_EDIT,
                        }}
                        buttonLog={{
                            show: Boolean(survey?.id),
                        }}
                        onHistoricalShow={toggleHistorical}
                    />
                }
            >
                <LayoutModule
                    title="Encuesta"
                    showTitle={false}
                    titleChildren="Información general"
                    icon={<AssignmentIcon sx={{ color: 'primary.main' }} />}
                >
                    <SurveyData survey={survey} loading={loading} />
                </LayoutModule>

                <Box sx={{ mt: 3 }}>
                    <LayoutModule
                        title="Preguntas"
                        showTitle={false}
                        titleChildren="Preguntas de la encuesta"
                        icon={<QuizIcon sx={{ color: 'primary.main' }} />}
                    >
                        <SurveyQuestions surveyId={survey?.id} />
                    </LayoutModule>
                </Box>
            </LayoutModule>
            <SurveyRegisterHistory survey={survey} />
        </>
    );
};
